"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerRailItem = void 0;
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var DrawerContext_1 = require("./DrawerContext");
var createStyles_1 = __importDefault(require("@material-ui/core/styles/createStyles"));
var makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
var Avatar_1 = __importDefault(require("@material-ui/core/Avatar"));
var ButtonBase_1 = __importDefault(require("@material-ui/core/ButtonBase"));
var Divider_1 = __importDefault(require("@material-ui/core/Divider"));
var Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var Drawer_1 = require("./Drawer");
var types_1 = require("./types");
var color_1 = __importDefault(require("color"));
var clsx_1 = __importDefault(require("clsx"));
var useStyles = makeStyles_1.default(function (theme) {
    // approximates the [200] color but not perfectly because the theme does not have that explicit color
    var lightenedPrimary = color_1.default(theme.palette.type === 'dark' ? theme.palette.primary.dark : theme.palette.primary.main)
        .lighten(0.83)
        .desaturate(0.39)
        .string();
    var fivePercentOpacityPrimary = color_1.default(theme.palette.type === 'dark' ? theme.palette.primary.dark : theme.palette.primary.main)
        .fade(0.95)
        .string();
    var twentyPercentOpacityPrimary = color_1.default(theme.palette.type === 'dark' ? theme.palette.primary.dark : theme.palette.primary.main)
        .fade(0.8)
        .string();
    return createStyles_1.default({
        root: {
            width: Drawer_1.RAIL_WIDTH,
            minHeight: Drawer_1.RAIL_WIDTH,
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'default',
            padding: function (props) { return "1rem " + (props.statusColor ? theme.spacing(1) : theme.spacing(0.5)) + "px"; },
            textAlign: 'center',
            backgroundColor: function (props) { return props.backgroundColor || 'transparent'; },
            '&:hover': {
                backgroundColor: function (props) { return (props.onClick ? theme.palette.action.hover : undefined); },
            },
        },
        active: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: function (props) {
                return props.activeItemBackgroundColor ||
                    (theme.palette.type === 'light' ? fivePercentOpacityPrimary : twentyPercentOpacityPrimary);
            },
        },
        condensed: {
            width: Drawer_1.RAIL_WIDTH_CONDENSED,
            minHeight: Drawer_1.RAIL_WIDTH_CONDENSED,
        },
        cursorPointer: {
            cursor: 'pointer',
        },
        divider: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
        },
        icon: {
            color: function (props) { return props.itemIconColor || theme.palette.text.primary; },
            backgroundColor: 'transparent',
            height: 'auto',
            width: 'auto',
            overflow: 'visible',
        },
        itemActive: {
            '& $icon': {
                color: function (props) {
                    return props.activeItemIconColor ||
                        (theme.palette.type === 'light' ? theme.palette.primary.main : lightenedPrimary);
                },
            },
            '& $title': {
                color: function (props) {
                    return props.activeItemFontColor ||
                        (theme.palette.type === 'light' ? theme.palette.primary.main : lightenedPrimary);
                },
            },
        },
        ripple: {
            backgroundColor: theme.palette.primary.main,
        },
        statusStripe: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            width: 6,
            zIndex: 100,
            backgroundColor: function (props) { return props.statusColor; },
        },
        title: {
            lineHeight: '1rem',
            wordBreak: 'break-word',
            hyphens: 'auto',
            zIndex: 200,
            color: function (props) { return props.itemFontColor || theme.palette.text.primary; },
        },
        titleActive: {
            fontWeight: 600,
        },
    });
});
var DrawerRailItemRender = function (props, ref) {
    var _a, _b;
    var 
    /* eslint-disable @typescript-eslint/no-unused-vars */
    activeItemBackgroundColor = props.activeItemBackgroundColor, activeItemFontColor = props.activeItemFontColor, activeItemIconColor = props.activeItemIconColor, backgroundColor = props.backgroundColor, itemFontColor = props.itemFontColor, itemIconColor = props.itemIconColor, 
    /* eslint-enable @typescript-eslint/no-unused-vars */
    divider = props.divider, _c = props.ripple, ripple = _c === void 0 ? true : _c, _d = props.classes, classes = _d === void 0 ? {} : _d, itemCondensed = props.condensed, hidden = props.hidden, icon = props.icon, itemID = props.itemID, onClick = props.onClick, 
    // onItemSelect,
    _e = props.title, 
    // onItemSelect,
    title = _e === void 0 ? '' : _e, ButtonBaseProps = props.ButtonBaseProps, statusColor = props.statusColor, disableRailTooltip = props.disableRailTooltip, directButtonBaseProps = __rest(props, ["activeItemBackgroundColor", "activeItemFontColor", "activeItemIconColor", "backgroundColor", "itemFontColor", "itemIconColor", "divider", "ripple", "classes", "condensed", "hidden", "icon", "itemID", "onClick", "title", "ButtonBaseProps", "statusColor", "disableRailTooltip"]);
    var _f = DrawerContext_1.useDrawerContext(), activeItem = _f.activeItem, onItemSelect = _f.onItemSelect, _g = _f.condensed, drawerCondensed = _g === void 0 ? false : _g;
    var active = activeItem === itemID;
    var condensed = itemCondensed !== undefined ? itemCondensed : drawerCondensed;
    var defaultClasses = useStyles(props);
    var hasAction = Boolean(onClick || onItemSelect);
    // Customize the color of the Touch Ripple
    var RippleProps = ripple && hasAction
        ? {
            TouchRippleProps: {
                classes: {
                    child: clsx_1.default(defaultClasses.ripple, classes.ripple),
                },
            },
        }
        : {};
    var combine = react_1.useCallback(function (className) { return clsx_1.default(defaultClasses[className], classes[className]); }, [defaultClasses, classes]);
    var getIcon = react_1.useCallback(function () {
        if (icon) {
            return react_1.default.createElement(Avatar_1.default, { className: combine('icon') }, icon);
        }
    }, [icon, combine]);
    var onClickAction = react_1.useCallback(function (e) {
        if (onItemSelect) {
            onItemSelect(itemID);
        }
        if (onClick) {
            onClick(e);
        }
    }, [onItemSelect, onClick, itemID]);
    var innerContent = (react_1.default.createElement(ButtonBase_1.default, __assign({ ref: ref }, ButtonBaseProps, directButtonBaseProps, { className: clsx_1.default(defaultClasses.root, classes.root, (_a = {},
            _a[defaultClasses.cursorPointer] = hasAction,
            _a[defaultClasses.itemActive] = active,
            _a[defaultClasses.condensed] = condensed,
            _a[classes.condensed] = condensed && classes.condensed,
            _a)), disableRipple: !ripple || !hasAction, onClick: onClickAction }, RippleProps),
        active && react_1.default.createElement("div", { className: combine('active') }),
        statusColor !== undefined && statusColor !== '' && (react_1.default.createElement("div", { className: combine('statusStripe'), "data-test": 'status-stripe' })),
        getIcon(),
        !condensed && (react_1.default.createElement(Typography_1.default, { variant: 'caption', className: clsx_1.default(defaultClasses.title, classes.title, (_b = {},
                _b[defaultClasses.titleActive] = active,
                _b[classes.titleActive] = active && classes.titleActive,
                _b)) }, title)),
        divider && react_1.default.createElement(Divider_1.default, { className: combine('divider') })));
    return hidden ? null : condensed && !disableRailTooltip ? (react_1.default.createElement(Tooltip_1.default, { title: title, placement: "right" }, innerContent)) : (innerContent);
};
/**
 * [DrawerRailItem](https://brightlayer-ui-components.github.io/react/?path=/info/components-drawer--get-read-me-story) component
 *
 * The `<DrawerRailItem>` is a simplified version of the `<DrawerNavItem>` that renders the `icon` and `title` only. When using the `condensed` version of the `<Drawer>`, the `title` will also be hidden. The `<DrawerRailItem>` cannot be nested.
 */
exports.DrawerRailItem = react_1.default.forwardRef(DrawerRailItemRender);
exports.DrawerRailItem.displayName = 'DrawerRailItem';
// @ts-ignore
exports.DrawerRailItem.propTypes = __assign(__assign({}, types_1.SharedStylePropTypes), { condensed: prop_types_1.default.bool, classes: prop_types_1.default.shape({
        root: prop_types_1.default.string,
        active: prop_types_1.default.string,
        condensed: prop_types_1.default.string,
        divider: prop_types_1.default.string,
        icon: prop_types_1.default.string,
        statusStripe: prop_types_1.default.string,
        title: prop_types_1.default.string,
        titleActive: prop_types_1.default.string,
        ripple: prop_types_1.default.string,
    }), hidden: prop_types_1.default.bool, icon: prop_types_1.default.element.isRequired, itemID: prop_types_1.default.string.isRequired, onClick: prop_types_1.default.func, statusColor: prop_types_1.default.string, title: prop_types_1.default.string, disableRailTooltip: prop_types_1.default.bool, 
    // @ts-ignore
    ButtonBaseProps: prop_types_1.default.object });
